import propTypes from "prop-types";
import { Typography } from "@mui/material";
import MyDivider from "src/components/layout/MyDivider";

export default function TabSubOtsikko(props) {
  const txt = props.txt;
  const show = props.show === undefined ? true : props.show;
  const noDivider = props.noDivider;

  if (!show) return null;

  return (
    <>
      <Typography
        variant="body2"
        align="center"
        color="secondary"
        className="noPrint"
        sx={{ paddingTop: "12px" }}>
        {txt}
      </Typography>
      {!noDivider && <MyDivider gutterHeight="8px" gutterTop />}
    </>
  );
}

TabSubOtsikko.propTypes = {
  txt: propTypes.string.isRequired,
  show: propTypes.bool,
  noDivider: propTypes.bool,
};
